module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/4-e2f0bcc2f6d386ff9c5c942d30528430.webp";